import { render } from "./EditCategory.vue?vue&type=template&id=6d9980fe&scoped=true&ts=true"
import script from "./EditCategory.vue?vue&type=script&lang=ts"
export * from "./EditCategory.vue?vue&type=script&lang=ts"

import "./EditCategory.vue?vue&type=style&index=0&id=6d9980fe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9980fe"]])

export default __exports__